import { SubmitHandler, useForm } from "react-hook-form";
import { Button, Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { Cancel, EmailAddress, Name, Phone, Save } from "../../../../../../constants";
import { useAppDispatch } from "../../../../../../reduxToolkit/hooks";
import { createUser } from "../../../../../../reduxToolkit/reducers/contactSlice";
import { FormContentProps, ContactFormProps } from "../../../../../../types/Applications";

// This component displays the contact form to add contacts.
const FormContent: React.FC<FormContentProps> = ({ setModal, toggle }) => {

  const dispatch = useAppDispatch();
  const { register, handleSubmit, formState: { errors } } = useForm<ContactFormProps>();
  const addContact: SubmitHandler<ContactFormProps> = (data) => {
    if (data) {
      dispatch(createUser({ data, defaultUser: `user/user.png` }));
      setModal(false);
    }
  };

  return (
    <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(addContact)}>
      <Row className="g-2">
        <Col md="12" className="mb-3 mt-0">
          <Label>{Name}</Label>
          <Row>
            <Col sm="6">
              <input type="text" className={`form-control ${`${errors.name ? "is-invalid" : "is-valid"}`}`} placeholder="First Name" {...register("name", { required: true })} />
              {errors.name && <FormFeedback className="text-danger">{"First name is required"}</FormFeedback>}
            </Col>
            <Col sm="6">
              <input type="text" className={`form-control ${`${errors.surname ? "is-invalid" : "is-valid"}`}`} placeholder="Last Name" {...register("surname", { required: true })} />
              {errors.surname && <FormFeedback className="text-danger">{"Last name is required"}</FormFeedback>}
            </Col>
          </Row>
        </Col>
        <Col md="12" className="mb-3 mt-0">
          <Label>{EmailAddress}</Label>
          <input type="email" className={`form-control ${`${errors.email ? "is-invalid" : "is-valid"}`}`} {...register("email", { required: true })} />
          {errors.email && <FormFeedback className="text-danger">{"Please enter the email"}</FormFeedback>}
        </Col>
        <Col md="12" className="mb-3 mt-0">
          <Label>{Phone}</Label>
          <Row>
            <Col sm="6">
              <input type="number" className={`form-control ${`${errors.mobile ? "is-invalid" : "is-valid"}`}`} {...register("mobile", { required: true })} />
              {errors.mobile && <FormFeedback className="text-danger">{"Please enter mobile number"}</FormFeedback>}
            </Col>
            <Col sm="6">
              <Input type="select">
                <option>{"Mobile"}</option>
                <option>{"Work"}</option>
                <option>{"Others"}</option>
              </Input>
            </Col>
          </Row>
        </Col>
      </Row>
      <Button color="secondary" className="me-2" type="submit">{Save}</Button>
      <Button color="primary" onClick={toggle}>{Cancel}</Button>
    </Form>
  );
};
export default FormContent;